export default __webpack_public_path__ + "static/media/QM.bd5f8a2c.png";